module.exports = __webpack_public_path__ + "static/media/star_big.57abbc33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/star_big.svg
// module id = 320
// module chunks = 2